import {
  JiraSoftwareIcon,
  JiraServiceManagementIcon,
  JiraWorkManagementIcon,
  JiraProductDiscoveryIcon,
  ConfluenceIcon
} from '@atlaskit/logo';

export interface Entitlement {
  entitlementId: string;
  siteName: string;
  productAndPlanName: string;
  productKey: ProductKey;
  daysLeftInTrial?: number;
}

export type Edition = 'free' | 'standard' | 'premium';

export interface Product {
  edition: Edition;
  trialEndDate: string;

  invoiceGroupId: string;
  ccpTransactionAccountId: string;
  ccpEntitlementId: string;
}

export interface Site {
  hostname: string;
  products?: Record<string, Product>;
}

const JSW_KEY = 'jira-software.ondemand';
const JSM_KEY = 'jira-servicedesk.ondemand';
const JWM_KEY = 'jira-core.ondemand';
const JPD_KEY = 'jira-product-discovery';
const CONFLUENCE_KEY = 'confluence.ondemand';

export type ProductKey =
  | typeof JSW_KEY
  | typeof JSM_KEY
  | typeof JWM_KEY
  | typeof JPD_KEY
  | typeof CONFLUENCE_KEY;

export const PRODUCT_NAME_BY_KEY = {
  [JSW_KEY]: 'Jira Software',
  [JSM_KEY]: 'Jira Service Management',
  [JWM_KEY]: 'Jira Work Management',
  [JPD_KEY]: 'Jira Product Discovery',
  [CONFLUENCE_KEY]: 'Confluence'
};

export const PRODUCT_ICON_BY_KEY = {
  [JSW_KEY]: JiraSoftwareIcon,
  [JSM_KEY]: JiraServiceManagementIcon,
  [JWM_KEY]: JiraWorkManagementIcon,
  [JPD_KEY]: JiraProductDiscoveryIcon,
  [CONFLUENCE_KEY]: ConfluenceIcon
};
